import { Platform } from "react-native"

// Native animation drivers are only supported on native... surprise!
export const useNativeDriver = Platform.OS !== "web"
